import adminApiClient from './apiClient.js';

export const categoriesApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/categories/', { params });
    return data;
  },
  hierarchy: async () => {
    const { data } = await adminApiClient.get('/categories/hierarchy');
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApiClient.post('/categories/', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApiClient.put(`/categories/${id}`, payload);
    return data;
  },
  remove: async (id, force = false) => {
    const { data } = await adminApiClient.delete(`/categories/${id}`, { params: { force } });
    return data;
  },
};

export default categoriesApi;
